import React from "react";
import { Callback } from "src/Modules/Auth/Callback";
import RemoveSupplyPublicFormWrapper from "src/components/Form/RemoveSupply/RemoveSupplyPublicFormWrapper";
import RemoveSupplyPublicFormSuccessWrapper from "src/components/Form/RemoveSupply/RemoveSupplyPublicFormSuccessWrapper";
import EICPublicFormWrapper from "src/components/Form/EIC/EICPublicFormWrapper";

import Reports from "../components/Reports";
import { routes as routeConsts } from "./RouteConstants";
import { NewPremise } from "src/screens/new-premise";
import { DraftPremise } from "src/screens/draft-premise";
import { Projects } from "src/screens/projects";
import { Premises } from "src/screens/premises";
import { Changes } from "src/screens/changes";
import { Drafts } from "src/screens/drafts";
import { Tasks } from "src/screens/tasks";
import { Claim } from "src/screens/claim";
import { PremisesByProject } from "src/screens/premises-by-project";
import { ChangeRequest } from "src/screens/change-request";
import { RemoveSupply } from "src/screens/remove-supply";
import { DraftChangeRequest } from "src/screens/draft-change-request";
import { DraftRemoveSupply } from "src/screens/draft-remove-supply";

export enum RouteType {
  PRIVATE,
  PUBLIC,
  MIXED,
}

export const ROUTES_SUPPORTING_PERMISSIONS = [
  RouteType.PRIVATE,
  RouteType.MIXED,
];

export interface IRoute {
  path: string;
  component: React.ComponentType<any>;
  title?: string;
  routes?: string;
  type: RouteType;
  permission?: string;
  usePageLevelLayout?: boolean;
  trackingPageName?: string;
  userRole?: string;
}

const PageTitleSuffix = "- Origin Connect";

/**
 * @deprecated this is exported as there are a number of components referencing routes directly,
 * which in turn created a circular reference.
 *
 * If you are looking at this, please make sure that any components you touched which have route
 *   references that arent direct.
 */
export const routes = routeConsts;

export const routeConfig: IRoute[] = [
  {
    component: Callback,
    path: `${routeConsts.callback}`,
    title: `Redirecting - ${PageTitleSuffix}`,
    type: RouteType.PUBLIC,
  },
  {
    component: Projects,
    path: `${routeConsts.projects}`,
    title: `Projects ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "projects",
  },
  {
    component: PremisesByProject,
    path: `${routeConsts.premisesByProject}`,
    title: `Premises By Project ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "premises-by-project",
  },
  {
    component: Premises,
    path: `${routeConsts.premises}`,
    title: `Premises ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "premises",
  },
  {
    component: Changes,
    path: `${routeConsts.changes}`,
    title: `Changes ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "changes",
  },
  {
    component: Drafts,
    path: `${routeConsts.drafts}`,
    title: `Drafts ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "drafts",
  },
  {
    component: Tasks,
    path: `${routeConsts.tasks}`,
    title: `Tasks ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "tasks",
  },
  {
    component: NewPremise,
    path: `${routeConsts.newPremise}`,
    title: `New Premises ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "new-premise",
  },
  {
    component: DraftPremise,
    path: `${routeConsts.draftPremise}`,
    title: `Draft Premises ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "draft-premise",
  },
  {
    component: Claim,
    path: `${routeConsts.claim}`,
    title: `Claim EWR`,
    type: RouteType.PRIVATE,
    trackingPageName: "claim",
  },
  {
    component: ChangeRequest,
    path: `${routeConsts.changeRequest}`,
    title: `Change Request ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "change-request",
  },
  {
    component: DraftChangeRequest,
    path: `${routeConsts.draftChangeRequest}`,
    title: `Change Request ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "draft-change-request",
  },
  {
    component: Reports,
    path: `${routeConsts.reports}`,
    title: `Reports`,
    type: RouteType.PRIVATE,
    trackingPageName: "reports",
  },
  {
    component: RemoveSupply,
    path: `${routeConsts.removeSupply}`,
    title: `Remove Supply ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "remove-supply",
  },
  {
    component: DraftRemoveSupply,
    path: `${routeConsts.draftRemoveSupply}`,
    title: `Remove Supply ${PageTitleSuffix}`,
    type: RouteType.PRIVATE,
    trackingPageName: "draft-remove-supply",
  },
  {
    component: RemoveSupplyPublicFormWrapper,
    path: `${routeConsts.publicRemoveSupply}`,
    title: `Remove Supply ${PageTitleSuffix}`,
    type: RouteType.PUBLIC,
    trackingPageName: "public-remove-supply",
  },
  {
    component: RemoveSupplyPublicFormSuccessWrapper,
    path: `${routeConsts.publicRemoveSupplySuccess}`,
    title: `Remove Supply Success ${PageTitleSuffix}`,
    type: RouteType.PUBLIC,
    trackingPageName: "public-remove-supply-success",
  },
  {
    component: EICPublicFormWrapper,
    path: `${routeConsts.publicEICForm}`,
    title: `EIC Public Form ${PageTitleSuffix}`,
    type: RouteType.PUBLIC,
    trackingPageName: "public-eic-form",
  },
];

class RouteConfigHelper {
  public getRouteForPath = (path: string) => {
    return routeConfig.find((item) => item.path === path);
  };
}

export const routeConfigHelper = new RouteConfigHelper();
